import moment from "moment-timezone";
import CryptoJS from "crypto-js/core";
import AES from "crypto-js/aes";
import _ from "underscore";
import errorText from "../i18n/en/server-side-validation-errors.json";
import * as config from "../app.config";

//should move this to app.config
const APPLICATION_MAP = {
  MutationDetection: "Mutation Detection",
  GeneExpression: "Gene Expression",
  CopyNumberDetermination: "Copy Number Determination",
  GenomeEditDetection: "Genome Edit Detection",
  GeneTherapy: "Cell and Gene Therapy",
  ExpertDesign: "Expert Design",
  "MutationDetection Two Tube": "Mutation Detection Two Tube",
};

const FLUOROPHORE_MAP = {
  FAM: "FAM",
  HEX: "HEX",
  "FAM/HEX": "FAM/HEX",
  CY5: "Cy5",
  Cy5: "Cy5",
  Cy5_5: "Cy5.5",
  CY5_5: "Cy5.5",
  FAM_HEX: "FAM + HEX",
  CY5_CY5_5: "Cy5 + Cy5.5",
  Cy5_Cy5_5: "Cy5 + Cy5.5",
  "CY5/CY5_5": "Cy5/Cy5.5",
};

export function formatAssayApplicationType(type) {
  const applicationType = type
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, function (str) {
      return str.toUpperCase();
    });

  return applicationType;
}

export function formatAssayFormat(fmt) {
  const assayFormat =
    fmt &&
    fmt.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
      return str.toUpperCase();
    });
  return assayFormat;
}

export function formatStatus(status) {
  let output = "";

  switch (status.toLowerCase()) {
    case "notfound":
    case "NotFound":
    case "NOTFOUND":
      output = "Not Found";
      break;
    case "DONE":
    case "done":
    case "Done":
      output = "Done";
      break;
    default:
      output = status;
  }

  return output;
}

export function formatDateTime(dt) {
  return moment.utc(dt).tz("America/Los_Angeles").format("YYYY-MM-DD HH:mm:ss");
}
const key = "A80632BF994B270389710EA7DD90F3152A2B161BEC8A4BD22400571C9D3C24D3";
const iv = "CFD825F81C6ACBB75125C3B6802F25BF";

export function encrypt(plain_text) {
  var key_binary = CryptoJS.enc.Hex.parse(key);
  var iv_binary = CryptoJS.enc.Hex.parse(iv);
  var encrypted_text = AES.encrypt(plain_text, key_binary, {
    iv: iv_binary,
  });
  return encrypted_text.toString();
}

export function decrypt(encrypted_text) {
  var key_binary = CryptoJS.enc.Hex.parse(key);
  var iv_binary = CryptoJS.enc.Hex.parse(iv);
  var plain_text = CryptoJS.AES.decrypt(encrypted_text, key_binary, {
    iv: iv_binary,
  });
  return plain_text;
}

export function formatAPI(api, endpoint) {
  return `${api}/${endpoint}`;
}

export function formatTradeMark(name) {
  return name.replace("{TRADE_MARK_SIGN}_", "");
}

export function formatTradeMarkForCart(name) {
  return name.replace("™", "").replace("\u00a0", "");
}

export function removeSpaces(value) {
  return value.trim();
}

export function joinSpaces(value) {
  return value.split(" ").join("");
}

export function processSequence(sequence) {
  // let leftList = sequence.split('{')[0].split("");
  // let sequenceList = sequence.split('{')[1].split('}')[0].split("");
  // sequenceList = ['{', ...sequenceList, '}'];
  // let rightList = sequence.split('}')[1].split("");

  return sequence.split("");
}

export function moveRight(
  rightSequence = [],
  leftSequence = [],
  currentIndex = 0,
  thumbStopper = 0
) {
  if (
    !rightSequence ||
    _.isNull(rightSequence) ||
    _.isEmpty(rightSequence || currentIndex === thumbStopper)
  ) {
    return { rightSequence, leftSequence };
  } else {
    leftSequence.push(rightSequence.shift());
    return { rightSequence, leftSequence };
  }
}

export function moveLeft(
  rightSequence = [],
  leftSequence = [],
  currentIndex = 0,
  thumbStopper = 0
) {
  if (
    !leftSequence ||
    _.isNull(leftSequence) ||
    _.isEmpty(leftSequence) ||
    currentIndex === thumbStopper
  ) {
    return { rightSequence, leftSequence };
  } else {
    rightSequence.unshift(leftSequence.pop());
    return { rightSequence, leftSequence };
  }
}

export function round(num, precision) {
  num = parseFloat(num);
  if (!precision) return num;
  return Math.round(num / precision) * precision;
}

export function scaleCoordinates(clientX, startingPoint, spanLength = 10) {
  //console.log(clientX - startingPoint,"difference", round((clientX - startingPoint), 10),(round((clientX - startingPoint), 10))/10)
  return round(Math.max(clientX - startingPoint, spanLength), 10) / 10;
}

export function calculateCoordinates(
  index,
  geneElementInSingleLine,
  spanHeight,
  spanLength
) {
  if (geneElementInSingleLine > 0) {
    /**
     * The result format of the initialX is of array i.e
     * first line is represented with `0`, 2nd with `1`
     */

    const initialY = Math.floor(index / geneElementInSingleLine) * spanHeight;
    const initialX = (index % geneElementInSingleLine) * spanLength;

    // Filter negative values during initialization.
    const startingY = Math.max(0, initialY);
    const startingX = Math.max(0, initialX);

    return { startingX: startingX, startingY: startingY };
  }
}

export function calculateIndex(
  x,
  y,
  geneElementInSingleLine,
  spanLength,
  spanHeight
) {
  const lineNumber = Math.max(0, y) / spanHeight;
  // convert it to array format to since we are calculating the index
  const elementNumberInLine = Math.max(0, x) / spanLength;
  const index = lineNumber * geneElementInSingleLine + elementNumberInLine;
  // console.log(lineNumber,elementNumberInLine,index, "in function");
  return index;
}

export function insertCutSites(start, end, sequence) {
  var sequence1 = cutSiteFormat(start, "{", sequence);
  var sequence2 = cutSiteFormat(end, "}", sequence1);
  return sequence2;
}
export function cutSiteFormat(site, symbol, sequence) {
  var sequence1 = sequence.slice(0, site) + symbol + sequence.slice(site);

  return sequence1;
}

export function formatExpectedAmplicons(expectedAmplicon) {
  if (!expectedAmplicon || _.isEmpty(expectedAmplicon)) {
    return [];
  }
  var cutSites = _.findWhere(expectedAmplicon.features, { type: "EditRegion" });
  var leftPart = expectedAmplicon.sequence.slice(0, cutSites.start) + "{";
  var rightPart = "}" + expectedAmplicon.sequence.slice(cutSites.end);
  var middlePart = expectedAmplicon.sequence.slice(
    cutSites.start,
    cutSites.end
  );
  return { left: leftPart, right: rightPart, middle: middlePart };
}

export function firstSeventeen(value) {
  return value.substring(0, 17);
}

export function processOrderObject(skuMap) {
  let newSkuMap = [];
  let skuSizes = (skuMap && Object.keys(skuMap).sort()) || [];
  !_.isEmpty(skuMap) &&
    _.map(skuSizes, (value) => {
      newSkuMap.push({ size: value, sku: skuMap[value] });
    });
  return newSkuMap.sort(function (a, b) {
    return parseInt(a.size) - parseInt(b.size);
  });
}

export function processOrderingInfo(orderingInfo) {
  if (orderingInfo && _.isEmpty(orderingInfo)) {
    return { ...orderingInfo, skuMap: processOrderObject(orderingInfo.skuMap) };
  }
}

export function formatGenomeOrganism(organism) {
  return organism.split("_").join(" ");
}

export function changeFormatForOther(organism) {
  if (organism === "None") {
    return "Organism Unspecified";
  } else {
    return organism;
  }
}

export function mapAppType(applicationType) {
  return APPLICATION_MAP[applicationType];
}

export function doesNotExist(obj) {
  return (
    _.isEmpty(obj) ||
    _.isUndefined(obj) ||
    _.isNull(obj) ||
    obj === "" ||
    obj === null
  );
}

export function wait(ms) {
  var start = new Date().getTime();
  var end = start;
  while (end < start + ms) {
    end = new Date().getTime();
  }
}

export function processExonic(exonic) {
  let output = "";
  switch (exonic) {
    case "exon-exonjunction":
    case "intron_spanning":
    case "IntronSpanning":
      output = "Yes";
      break;
    case "Exonic":
      output = "No";
      break;
    default:
      output = "Unknown";
  }
  return output;
}

function _toWords(input) {
  var regex = /[A-Z\xC0-\xD6\xD8-\xDE]?[a-z\xDF-\xF6\xF8-\xFF]+|[A-Z\xC0-\xD6\xD8-\xDE]+(?![a-z\xDF-\xF6\xF8-\xFF])|\d+/g;

  return input.match(regex);
}

export function toCamel(str) {
  let inputArray = _toWords(str);

  let result = "";

  for (let i = 0, len = inputArray.length; i < len; i++) {
    let currentStr = inputArray[i];

    let tempStr = currentStr.toLowerCase();

    if (i != 0) {
      // convert first letter to upper case (the word is in lowercase)
      tempStr = tempStr.substr(0, 1).toUpperCase() + tempStr.substr(1);
    }

    result += tempStr;
  }
  return result;
}

export function processEditRegionSequence(editRegionSequence) {
  //console.log(editRegionSequence,"editRegionSequence");
  return buildEditRegionSequenceObject(editRegionSequence);
}

export function buildEditRegionSequenceObject(editRegionSequence) {
  var edited = parseEditRegionSequence(editRegionSequence).edit,
    native = parseEditRegionSequence(editRegionSequence).native,
    minLength = Math.min(edited.length, native.length),
    matches = _.map(_.range(minLength), function (i) {
      if (
        native.charAt(i).toUpperCase() === "N" ||
        edited.charAt(i).toUpperCase() === "N"
      ) {
        return " ";
      } else {
        return native.charAt(i) === edited.charAt(i) ? " " : "*";
      }
    }).join("");

  var sequences = [];
  var segmentLength = edited.length;
  var maxLength = 90;
  // Split the sequences into strings with having a defined max length
  for (var cutLength = 0; cutLength < segmentLength; cutLength += maxLength) {
    sequences.push({
      edited: edited.slice(cutLength, maxLength + cutLength),
      native: native.slice(cutLength, maxLength + cutLength),
      match: matches.slice(cutLength, maxLength + cutLength),
    });
  }
  return sequences;
}

function parseEditRegionSequence(editRegionSequence) {
  var inNative = false;
  var inEdit = false;
  var nativeCount = 0;
  var editCount = 0;
  var native = "";
  var nativeFragment = "";
  var edit = "";
  var editFragment = "";

  for (var i = 0; i < editRegionSequence.length; i++) {
    var char = editRegionSequence.charAt(i);

    if (/[ACTGN]/.test(char.toUpperCase())) {
      if (!inNative && !inEdit) {
        // outside of braces so common to edit and native regions
        native += char;
        edit += char;
      } else if (inNative) {
        // increase native region
        nativeFragment += char;
        nativeCount++;
      } else if (inEdit) {
        // increase edit region
        editFragment += char;
        editCount++;
      }
    } else if (/\[/.test(char)) {
      // encountered '[' which indicates beginning of native region
      inNative = true;
      nativeCount = 0;
    } else if (/\//.test(char)) {
      // encountered '/' which indicates beginning of edit region
      inNative = false;
      inEdit = true;
      editCount = 0;
    } else if (/]/.test(char)) {
      // encountered ']' which indicates end of edit region
      // pad the strings with hyphens to account for length discrepancies if necessary

      if (nativeCount > editCount) {
        // edit += _.pad( editFragment, nativeCount, '-',"right");
        edit += editFragment.padEnd(nativeCount, "-");
        native += nativeFragment;
      } else if (editCount > nativeCount) {
        //native += _.pad( nativeFragment, editCount, '-',"right");
        native += nativeFragment.padEnd(editCount, "-");
        edit += editFragment;
      } else if (editCount === nativeCount) {
        native += nativeFragment;
        edit += editFragment;
      }

      // reset counters and flags
      inNative = false;
      inEdit = false;
      nativeCount = 0;
      editCount = 0;
      editFragment = "";
      nativeFragment = "";
    }
  }

  return {
    native: native.toUpperCase(),
    edit: edit.toUpperCase(),
  };
}

export function objToCamel(o) {
  var newO, origKey, newKey, value;
  if (o instanceof Array) {
    return o.map(function (value) {
      if (typeof value === "object") {
        value = objToCamel(value);
      }
      return value;
    });
  } else {
    newO = {};
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (
          origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey
        ).toString();
        value = o[origKey];
        if (
          value instanceof Array ||
          (value !== null && value.constructor === Object)
        ) {
          value = objToCamel(value);
        }
        newO[newKey] = value;
      }
    }
  }
  return newO;
}

export function calibrateThumb(index, start, end) {
  if (index < start) {
    return index;
  }
  if (index >= start && index < end) {
    return index - 1;
  }
  if (index >= end) {
    return index - 2;
  }
}

export const handleValidationErrors = (code) => {
  if (!code) {
    return "";
  }
  var error = errorText.error;
  var path = code.split(".");

  for (var i in path) {
    error = error[path[i]];
    if (error === undefined) {
      return "";
    }
  }
  return error;
};

export const formatUniversalAssayName = (commercializedId) => {
  var output =
    (_.findWhere(config.UNIVERSAL_ASSAY_OPTIONS, { value: commercializedId }) &&
      _.findWhere(config.UNIVERSAL_ASSAY_OPTIONS, { value: commercializedId })
        .name) ||
    "";
  return output;
};

export const formatUniversalAssayFluorophores = (commercializedId) => {
  var output =
    (_.findWhere(config.UNIVERSAL_ASSAY_OPTIONS, { value: commercializedId }) &&
      _.findWhere(config.UNIVERSAL_ASSAY_OPTIONS, { value: commercializedId })
        .fluorophores) ||
    "";
  return output;
};

export const formatFluorophores = (fluorophores) => {
  return FLUOROPHORE_MAP[fluorophores];
};

export const getSorting = (order, orderBy) => {
  if (orderBy ===""){
    return undefined
  }
  const output =
    order === "desc"
      ? (a, b) => (b[orderBy] < a[orderBy] ? 1 : -1)
      : (a, b) => (a[orderBy] < b[orderBy] ? 1 : -1);
  return output;
};

export const processSearchParameter = (val) => {
  if (!val) {
    return "";
  }
  return decodeURI(val);
};


function firstLetterLower(string) {
  if (string === "" || string === undefined) {
    return "";
  }

  let newString = string.toUpperCase();
  return newString.charAt(0).toLowerCase() + newString.slice(1);
}

export const convertToCaseFormat = (assayCommercialId) => {
  let processedCommercialID = firstLetterLower(assayCommercialId);
  return processedCommercialID
    .replace("HSA", "Hsa")
    .replace("MMU", "Mmu")
    .replace("RNO", "Rno");
};
